import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { theme } from 'styles';
import { DeleteCartItem } from 'components/shared';
import DeleteModalToggle from './DeleteModalToggle';
import QuantityForm from './QuantityForm';
import RecurringToggleForm from './RecurringToggleForm';

const CartItemWrapper = styled.div`
  position: relative;
  border-bottom: 1px solid ${theme.colors.border};
  padding: ${theme.sp.s} 0px;
`;
const CartItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;
const CartItemSecondRow = styled.div`
  display: flex;
  justify-content: space-between;
`;
const CartItemText = styled.div``;
const CartItemProduct = styled.div`
  margin-right: 10px;
`;
const CartItemAmount = styled.div`
  color: ${theme.colors.grey};
`;
const CartItemUpdate = styled.a`
  color: ${theme.colors.blue};
  text-decoration: none;
`;
const CartItemPrice = styled.div``;

// HACK
const nameParts = name => name.split(' for ');

class CartItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isQuantityVisible: false,
      isDeleteVisible: false,
    };
    this.toggleUpdateModal = this.toggleUpdateModal.bind(this);
    this.toggleDeleteModal = this.toggleDeleteModal.bind(this);
  }

  toggleUpdateModal() {
    this.setState({ isQuantityVisible: !this.state.isQuantityVisible });
  }

  toggleDeleteModal() {
    this.setState({ isDeleteVisible: !this.state.isDeleteVisible });
  }

  render() {
    const { item } = this.props;
    return (
      <CartItemWrapper>
        <QuantityForm
          cartItem={item}
          isVisible={this.state.isQuantityVisible}
          onClick={this.toggleUpdateModal}
        />
        <DeleteCartItem
          cartItem={item}
          isVisible={this.state.isDeleteVisible}
          onClick={this.toggleDeleteModal}
        />
        <CartItemRow>
          <CartItemText>
            <CartItemProduct>{nameParts(item.name)[0]}</CartItemProduct>
            <CartItemAmount>
              {nameParts(item.name)[1]}
              {item.sellableType === 'Product' && (
                <CartItemUpdate href="#" onClick={this.toggleUpdateModal}>
                  Update
                </CartItemUpdate>
              )}
            </CartItemAmount>
          </CartItemText>
          <CartItemPrice>${item.subtotal}</CartItemPrice>
        </CartItemRow>
        <CartItemSecondRow>
          <RecurringToggleForm cartItem={item} />
          <DeleteModalToggle onClick={this.toggleDeleteModal} />
        </CartItemSecondRow>
      </CartItemWrapper>
    );
  }
}

CartItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.integer,
    name: PropTypes.string,
    quantity: PropTypes.integer,
  }).isRequired,
};

export default CartItem;



// WEBPACK FOOTER //
// ./src/components/shared/CartDrawer/components/CartItem.jsx